export const propertyCategoryItems = [
  {
    title: "آپارتمان",
    image: "/assets/customer-landing.jpg",
    propertyValue: "1",
  },
  {
    title: "خانه و ویلا",
    image: "/assets/customer-landing.jpg",
    propertyValue: "2",
  },
  {
    title: "زمین و ملک کلنگی",
    image: "/assets/customer-landing.jpg",
    propertyValue: "6",
  },
  {
    title: "دفتر کار، دفاتر اداری و مطب",
    image: "/assets/customer-landing.jpg",
    propertyValue: "3",
  },
  {
    title: "مغازه و غرفه",
    image: "/assets/customer-landing.jpg",
    propertyValue: "4",
  },
  {
    title: "دفاتر صنعتی، کشاورزی و تجاری",
    image: "/assets/customer-landing.jpg",
    propertyValue: "5",
  },
] as const;
